import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";
import "../../App.scss";
import "./LandingPage.css";
// import YouTube from "react-youtube";
import axios from "axios";
// import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { purple } from "@material-ui/core/colors";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import PandaVideoImage from "../../assets/panda.png";
import psLogo from "../../assets/psLogo.png";
import todo from "../../assets/landingTodo.png";
import video from "../../assets/landingVideo.png";
import stats from "../../assets/landingStats.png";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Login from "../Login";
import Panda from "../components/Panda.js";

// import "node_modules/react-modal-video/scss/modal-video.scss";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const LandingPage = ({ signInSignal }) => {
  const classes = useStyles();

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const ColorButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(purple[500]),
      backgroundColor: "#8D448B",
      "&:hover": {
        backgroundColor: "#954893",
      },
    },
    label: {
      // textTransform: "capitalize",
    },
  }))(Button);

  // const EmailTextField = withStyles(() => ({
  //   root: {
  //     background: "#FFFFFF",
  //     marginRight: "0.8em",
  //     width: "20em",
  //   },
  // }))(TextField);

  const [navBarPos, setNavBarPos] = useState("navBarTop");
  const [isOpenVideo, setOpenVideo] = useState(false);
  const [value, setValue] = useState(""); // email input, change in the future
  const [emailWarning, setEmailWarning] = useState("");

  useEffect(() => {
    if (
      window.location.protocol === "http:" &&
      window.location.hostname !== "localhost"
    ) {
      window.location.href = window.location.href.replace("http:", "https:");
    } else {
      axios.post("/api/metrics/landingPage");
    }

    document.addEventListener("scroll", (e) => {
      let scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 100) {
        setNavBarPos("navBarMoved");
        // console.log("moved");
      } else {
        setNavBarPos("navBarTop");
        // console.log("top");
      }
    });
  }, []);

  const addEmailToWaitingList = (email) => {
    let isEmail = email.split("@");

    if (isEmail.length === 1) {
      setEmailWarning("not an email");
      return;
    }

    // if (isEmail.length == 2) {
    //   let isEdu = isEmail[isEmail.length - 1].split(".");
    //   setEmailWarning("it is an email");
    //   // if (isEdu[isEdu.length - 1].toLowerCase() !== "edu") {
    //   //   setEmailWarning("It hs to be a school email, ending in edu");
    //   // }
    //   return;
    // }

    axios.post("/api/metrics/addToWaitingList", { email: email });
    setEmailWarning("Thanks, we will contact you soon!");
    setValue("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      addEmailToWaitingList(value);
    }
  };

  return (
    <div className="landingPage">
      {/* NAVBAR */}
      <div className={`navBar primary-color ${navBarPos}`}>
        <div className="homeLogo">
          <h2>
            <a href="#homeWrap">
              <img alt="pairstudy logo" className="logo" src={psLogo}></img>
              PairStudy{" "}
            </a>{" "}
          </h2>
        </div>
        <div className="menu">
          <h2>
            <a href="#features">Features </a>
          </h2>
          <h2>
            <a href="#section2">Demo </a>
          </h2>
          <h2>
            <a href="#section3">About </a>
          </h2>
          <h2>
            <a href="#section4">Contact </a>
          </h2>
        </div>
        <div className="loginWrap" onClick={handleModalOpen}>
          Login
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={modalOpen}
          onClose={handleModalClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={modalOpen}>
            <Login signInSignal={signInSignal} closeModal={handleModalClose} />
          </Fade>
        </Modal>
      </div>
      {/* NAVBAR END*/}

      <div id="homeWrap" className="blockWrap primary-color">
        <div id="homeLeftWrap">
          <div className="missionWrap">
            <h1>A co-working space </h1>
            <h1>for students</h1>
            <p>Your productivity is our top priority. </p>
          </div>

          {/* <input>Not a Columbia University student? join the waitlist!</input> */}

          <h6 className="waitlistDescription">
            Not a Columbia or Barnard student? join the waitlist!
          </h6>
          <div className="wailistWrap">
            {/* <EmailTextField
              id="emailInput"
              label="Student Email"
              variant="filled"
              color="#ffffff"
              // onChange={handleEmail}
              onChange={(event) => {
                setValue(event.target.value);
              }}
              value={value}
              // defaultValue="panda@school.edu"
            /> */}
            <input
              className="emailInput"
              onChange={(event) => {
                setValue(event.target.value);
              }}
              type="email"
              value={value}
              onKeyDown={handleKeyDown}
              placeholder="school email"
            ></input>
            <br></br>
            <ColorButton
              variant="contained"
              color="primary"
              // className={classes.margin}
              onClick={() => addEmailToWaitingList(value)}
            >
              Join waitlist
            </ColorButton>
          </div>
          <p id="emailWarning">{emailWarning}</p>
          <h2 id="usedByWrap">
            {" "}
            {`Used by: Columbia University & Barnard College students`}
          </h2>
        </div>
        <div id="homeRightWrap">
          <Panda />

          {/* <div className="socialMedia">
            <a
              target="_blank"
              without="true"
              rel="noopener noreferrer"
              href="https://www.instagram.com/_pairstudy_/"
            >
              <svg
                id="instagamIcon"
                width="35"
                height="35"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.83325 11.5002C3.83325 9.46684 4.64099 7.51679 6.07877 6.07901C7.51655 4.64123 9.46659 3.8335 11.4999 3.8335H34.4999C36.5332 3.8335 38.4833 4.64123 39.9211 6.07901C41.3589 7.51679 42.1666 9.46684 42.1666 11.5002V34.5002C42.1666 36.5335 41.3589 38.4835 39.9211 39.9213C38.4833 41.3591 36.5332 42.1668 34.4999 42.1668H11.4999C9.46659 42.1668 7.51655 41.3591 6.07877 39.9213C4.64099 38.4835 3.83325 36.5335 3.83325 34.5002V11.5002ZM11.4999 7.66683C10.4833 7.66683 9.50823 8.0707 8.78934 8.78959C8.07045 9.50848 7.66659 10.4835 7.66659 11.5002V34.5002C7.66659 35.5168 8.07045 36.4919 8.78934 37.2107C9.50823 37.9296 10.4833 38.3335 11.4999 38.3335H34.4999C35.5166 38.3335 36.4916 37.9296 37.2105 37.2107C37.9294 36.4919 38.3333 35.5168 38.3333 34.5002V11.5002C38.3333 10.4835 37.9294 9.50848 37.2105 8.78959C36.4916 8.0707 35.5166 7.66683 34.4999 7.66683H11.4999ZM22.9999 17.2502C21.4749 17.2502 20.0124 17.856 18.9341 18.9343C17.8557 20.0126 17.2499 21.4752 17.2499 23.0002C17.2499 24.5252 17.8557 25.9877 18.9341 27.066C20.0124 28.1444 21.4749 28.7502 22.9999 28.7502C24.5249 28.7502 25.9875 28.1444 27.0658 27.066C28.1441 25.9877 28.7499 24.5252 28.7499 23.0002C28.7499 21.4752 28.1441 20.0126 27.0658 18.9343C25.9875 17.856 24.5249 17.2502 22.9999 17.2502ZM13.4166 23.0002C13.4166 20.4585 14.4263 18.0209 16.2235 16.2237C18.0207 14.4265 20.4583 13.4168 22.9999 13.4168C25.5416 13.4168 27.9791 14.4265 29.7764 16.2237C31.5736 18.0209 32.5833 20.4585 32.5833 23.0002C32.5833 25.5418 31.5736 27.9794 29.7764 29.7766C27.9791 31.5738 25.5416 32.5835 22.9999 32.5835C20.4583 32.5835 18.0207 31.5738 16.2235 29.7766C14.4263 27.9794 13.4166 25.5418 13.4166 23.0002ZM33.5416 15.3335C34.3041 15.3335 35.0354 15.0306 35.5745 14.4914C36.1137 13.9523 36.4166 13.221 36.4166 12.4585C36.4166 11.696 36.1137 10.9647 35.5745 10.4256C35.0354 9.8864 34.3041 9.5835 33.5416 9.5835C32.7791 9.5835 32.0478 9.8864 31.5087 10.4256C30.9695 10.9647 30.6666 11.696 30.6666 12.4585C30.6666 13.221 30.9695 13.9523 31.5087 14.4914C32.0478 15.0306 32.7791 15.3335 33.5416 15.3335Z"
                  fill="#AEB4BE"
                />
              </svg>
            </a>
          </div>*/}
        </div>
      </div>

      <div id="features" className="blockWrap featuresWrap secondary-color">
        <h1>Features</h1>
        <p>The tools you need to succeed at school</p>
        <div className="featureContentWrap">
          <div className="eachFeatureWrap">
            <h3>Study tools</h3>
            <img alt="todo list" src={todo} className="featureImage"></img>
            <p>Tools that will boost your productivity</p>
          </div>
          <div className="eachFeatureWrap">
            <h3>Virtual Library</h3>
            <img
              alt="virtual library"
              src={video}
              className="featureImage"
            ></img>
            <p>Connect with students within your university </p>
          </div>
          <div className="eachFeatureWrap">
            <h3>Statistic </h3>
            <img
              alt="Statistic of study session"
              src={stats}
              className="featureImage"
            ></img>
            <p>Keep an eye on your performance </p>
          </div>
        </div>
        {/* <p>More features are being created every week just for you</p> */}
      </div>

      {/* <div id="section2" className="blockWrap primary-color">
        <h1> Video </h1>
        <p>A quick walk through of PairStudy </p>

        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpenVideo}
          videoId="9zTWht5TLoA"
          onClose={() => setOpenVideo(false)}
        />
        <img
          id="demoVideo"
          alt="pairstudy video demo, click to listen"
          src={demoVideo}
          onClick={() => setOpenVideo(true)}
        ></img>
      </div> */}

      <div id="section3" className="blockWrap primary-color">
        <h1>About</h1>
        <p> Our Vision is to boot students' productivity and creativity </p>
        <div id="aboutWrap">
          <h2>The Story</h2>
          <p>
            After school went remote in 2020, we as students found it very
            difficult to stay productive. Therefore, we got together and started
            building the tools to keep us productive.
          </p>
          <h2>The Team</h2>
          <p>Samantha Bacelic, William Oseghare, Bennet Brown, Ahad Butt</p>
        </div>
      </div>

      <div id="section4" className="blockWrap secondary-color">
        <h1>Contact</h1>
        <p> us </p>
        <h3>hello@pairstudy.com</h3>
        <p> We are just an email away </p>
      </div>
    </div>
  );
};

export default LandingPage;
